<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';

	import { Alert, Button, Container, Modal, Stack, Text } from '@Shelly/shelly-design-system';
	import { labelForSubUnitId } from 'src/components/Scenes/helpers/notification_recipients_helpers';

	export let showModal = false;
	/** Numeric sub-unit ids that are stored on the action but no longer exist. */
	export let orphans: number[] = [];

	const dispatch = createEventDispatcher<{
		removeAndSave: void;
		keepAndSave: void;
		cancel: void;
	}>();

	const onClose = () => {
		dispatch('cancel');
	};
</script>

<Modal
	{showModal}
	on:close={onClose}
	title={$format('scene_notification_orphan_modal_title', {
		default: 'Recipients no longer in this home',
	})}
>
	<Container slot="content" padding="0">
		<Alert
			class="mb-m"
			type="warning"
			heading={$format('scene_notification_orphan_modal_heading', {
				default: 'Some recipients lost access to this home',
			})}
			message={$format('scene_notification_orphan_modal_info', {
				default:
					'These members are saved on the notification but no longer belong to this home and will not receive anything. Remove them now to keep the scene tidy, or keep them in case the user is re-invited later.',
			})}
		/>

		<Stack direction="column" gap="xs">
			{#each orphans as orphan (orphan)}
				<Text styleType="body-small" class="text-color-muted">
					<i class="fas fa-user-slash mr-xs" aria-hidden="true"></i>
					{labelForSubUnitId(orphan)}
				</Text>
			{/each}
		</Stack>
	</Container>

	<div slot="footer" class="d-flex justify-content-end flex-wrap gap-s">
		<Button
			variant="secondary"
			responsiveSize={{ sm: 'm' }}
			class="width-md-m width-sm-full"
			aria-label={$format('button_cancel', { default: 'Cancel' })}
			on:click={onClose}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			variant="secondary"
			responsiveSize={{ sm: 'm' }}
			class="width-md-m width-sm-full"
			aria-label={$format('scene_notification_orphan_modal_keep_button', {
				default: 'Keep and save',
			})}
			on:click={() => dispatch('keepAndSave')}
		>
			{$format('scene_notification_orphan_modal_keep_button', { default: 'Keep and save' })}
		</Button>
		<Button
			variant="primary"
			icon="fas fa-trash"
			responsiveSize={{ sm: 'm' }}
			class="width-md-m width-sm-full"
			aria-label={$format('scene_notification_orphan_modal_remove_button', {
				default: 'Remove and save',
			})}
			on:click={() => dispatch('removeAndSave')}
		>
			{$format('scene_notification_orphan_modal_remove_button', {
				default: 'Remove and save',
			})}
		</Button>
	</div>
</Modal>
